import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SendConfirmationComponent } from '../send-duplicate-confirmation/send-confirmation.component';
import { ReviewSubmitComponent } from '../review-and-submit/review-submit.component';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ConfirmationComponent } from '../confirmation/confirmation.component';

@Component({
  selector: 'app-send-confirmation-master',
  templateUrl: './send-confirmation-master.component.html',
  styleUrls: ['./send-confirmation-master.component.scss'],
  imports: [CommonModule, SendConfirmationComponent, ReviewSubmitComponent, ConfirmationComponent],
  standalone: true
})
export class SendConfirmationMasterComponent implements OnInit {
  currentStep$: Observable<number>;

  ngOnInit(): void {
    console.log('=== SendConfirmationMasterComponent ngOnInit called ===');
    console.log('Current URL at ngOnInit:', window.location.href);

    // Track router events to see any navigation happening
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      console.log('=== ROUTER NAVIGATION DETECTED ===');
      console.log('Navigated to:', event.url);
      console.log('Navigation ID:', event.id);

      if (event.url === '/' || event.url === '') {
        console.log('🚨 REDIRECT TO HOME DETECTED! 🚨');
        console.trace('Stack trace for redirect to home');
      }
    });

    this.currentStep$ = this.store.select(state => state.confirmationFlow.stepIndicatorIndex);
    this.currentStep$.pipe().subscribe((stepIndex) => {
      console.log('SendConfirmationMasterComponent - step indicator index changed:', stepIndex);
      console.log('Current URL after step change:', window.location.href);
    });

    // Add a timeout to check if we're still on the page after a few seconds
    setTimeout(() => {
      console.log('=== 3 SECOND CHECK ===');
      console.log('Still on send-confirmation page?', window.location.pathname.includes('/send-confirmation'));
      console.log('Current URL:', window.location.href);
    }, 3000);
  }

  constructor(
    private store: Store<{ confirmationFlow: { stepIndicatorIndex: number } }>,
    private router: Router
  ) {
    console.log('=== SendConfirmationMasterComponent constructor called ===');
    console.log('Current URL at constructor:', window.location.href);
  }
}
